import './Token-40fd0f77.css';

var classes = {"Token":"prc-Token-Token-L2-At"};

export { classes as default };
